import type { PropsWithChildren } from "react";

const DottedBackground = ({ children }: PropsWithChildren<{}>) => {
	return (
		<>
			<div className="absolute top-0 h-72 w-full bg-polka sm:h-96" />
			<div className="absolute top-0 h-72 w-full bg-linear-to-b from-transparent to-white sm:h-96 dark:to-slate-800" />
			<div className="relative">{children}</div>
		</>
	);
};

export default DottedBackground;
